// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\StripeTransactionListResponse

import { hydrateStripeTransaction, type StripeTransaction, type StripeTransactionApiResponse } from './stripeTransaction.gen';

export type StripeTransactionListApiResponse = {
	items: StripeTransactionApiResponse[];
};

export type StripeTransactionList = {
	items: StripeTransaction[];
};

export function hydrateStripeTransactionList(data: StripeTransactionListApiResponse): StripeTransactionList {
	return {
		...data,
		items: data.items.map(hydrateStripeTransaction),
	};
}